import { useEffect, useMemo, useReducer } from 'react'
import { AdvancedImage, placeholder, responsive } from '@cloudinary/react'
import styles from '../../SharedCalculatorCss.module.scss'
import { InputTextLabeled } from '../../../UI/inputs/InputTextLabeled/InputTextLabeled'
import { ButtonByAdam } from '../../../UI/buttons/ButtonByAdam/ButtonByAdam'
import { HeaderWithIcon } from '../../../UI/headers/CustomHeader/CustomHeader'
import { ErrorListMessage } from '../../../UI/MessageComponents/ErrorListMessage/ErrorListMessage'
import { SuccessMessage } from '../../../UI/MessageComponents/SuccessMessage/SuccessMessage'
import {
  initialRoundedPortionsReducer,
  roundedCakeReducer,
  RoundedPortionsReducerActionName
} from './RoundedPortionsReducer'
import { CalculatorOperations } from '../../../../helpers/cake'
import { useCloudinary } from '../../../../hooks/useCloudinary'

interface Props {
  countAutomatic: boolean
}

export const RoundedCake = ({ countAutomatic }: Props): JSX.Element => {
  const [calculator, dispatch] = useReducer(
    roundedCakeReducer,
    initialRoundedPortionsReducer
  )
  const calculate = (): void =>
    dispatch({ type: RoundedPortionsReducerActionName.CALCULATE_RESULT })
  const updateCalculatorData = (data: CalculatorOperations): void =>
    dispatch({
      type: RoundedPortionsReducerActionName.UPDATE_ROUNDED_PORTIONS_CALC_DATA,
      data
    })

  const { getImageInstance } = useCloudinary()

  const roundedCakeImage = useMemo(() => {
    const imageInstance = getImageInstance(
      'szkolamajcake/kalkulatory/tort_okragly_wzor'
    )

    return (
      <AdvancedImage
        cldImg={imageInstance}
        plugins={[responsive(), placeholder()]}
      />
    )
  }, [])

  useEffect((): void => {
    if (countAutomatic) {
      calculate()
    }
  }, [calculator.d, calculator.height])

  return (
    <section className={styles.CalculatorContainer}>
      <div className={styles.Content_Inputs}>
        <HeaderWithIcon headerType='typical'>Torty Okrągłe</HeaderWithIcon>

        <InputTextLabeled
          type='number'
          titleColor='pink'
          title='Podaj średnicę tortu'
          dataRequired
          value={calculator.d}
          placeholder='Podaj średnicę tortu'
          onChangeHandler={(val): void =>
            updateCalculatorData({ fieldName: 'd', fieldValue: val })
          }
        />

        <InputTextLabeled
          type='number'
          titleColor='blue'
          title='Podaj wysokość tortu'
          dataRequired
          value={calculator.height}
          placeholder='Podaj wysokość tortu'
          onChangeHandler={(val): void =>
            updateCalculatorData({ fieldName: 'height', fieldValue: val })
          }
        />

        {!countAutomatic && (
          <ButtonByAdam btnType='premium' onClick={(): void => calculate()}>
            Oblicz
          </ButtonByAdam>
        )}

        <div className={styles.ResultContainer}>
          {calculator.errors.length > 0 && (
            <ErrorListMessage
              title='Błędne wartości w kalkulatorze'
              errorList={calculator.errors}
            />
          )}
          {calculator.result && (
            <SuccessMessage>
              {'Ten tort przewidujemy na: od '}
              <strong>{calculator.result.MIN}</strong>
              {' do '}
              <strong>{calculator.result.MAX}</strong>
              {' porcji.'}
            </SuccessMessage>
          )}
        </div>
      </div>

      <div className={styles.Content_Image}>{roundedCakeImage}</div>
    </section>
  )
}
